module.exports = __webpack_public_path__ + "img/progress-bg.54c94aeb.png";